import { create } from "zustand";
import { readStoredSession, type SessionUser } from "./session";

export type { SessionUser, ViewConfig } from "./session";
export { sessionUserSchema, viewConfigSchema } from "./session";

type SessionUserState = {
  user: SessionUser | null;
  setUser: (user: SessionUser | null) => void;
};

// Hydrated synchronously at module init, not from an effect: the router runs
// its first beforeLoad from a layout effect, so a store that starts empty makes
// "signed in" briefly false on every hard reload and the auth guard would
// bounce a valid session to /login.
const sessionUserStore = create<SessionUserState>()((set) => ({
  user: readStoredSession(),
  setUser: (user: SessionUser | null) => set(() => ({ user })),
}));

export default sessionUserStore;
